import { Component } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { OrdersCoServices } from '../services';
import { OrdersLoaderPage } from '../orders-loader/orders-loader';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the TpvTicketPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-orders-select',
  templateUrl: 'orders-select.html',
})
export class OrdersSelectPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public ordersCoServices: OrdersCoServices,
    public globals: Globals,
    private alertCtrl: AlertController,
    public translate: TranslateService) {
  }

  openSendOrder() {

    const confirm = this.alertCtrl.create({
      title: this.translate.instant('instant-enviar-comanda'),
      message: this.translate.instant('instant-seguro-quieres-enviar-comanda'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          handler: () => {

          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.sendOrder();
          }
        }
      ]
    });
    confirm.present();
  }

  async sendOrder() {

    await this.ordersCoServices.sendOrderInServices();
    //this.navCtrl.pop();
    this.ordersCoServices.count_elements=0;//reset
    //this.globals.side_menu_active = 'order';
    //this.navCtrl.push(OrdersRoomPage);
    this.globals.side_menu_active = 'order';
    this.navCtrl.setRoot(OrdersLoaderPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/orders/orders-select/orders-select.ts